import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e5f32c56"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "velocity-value-text"
};
const _hoisted_3 = {
  key: 0,
  class: "badge"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "badge-text"
}, "Slow mover", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  return $options.max > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(['velocity', {
      'slow-mover': $props.slowMover
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.values, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      id: `${$data.id}-${index}`,
      class: "velocity-item",
      onMouseover: _cache[0] || (_cache[0] = $event => $data.show_velocity_value = true),
      onMouseleave: _cache[1] || (_cache[1] = $event => $data.show_velocity_value = false)
    }, [_withDirectives(_createElementVNode("div", {
      class: "velocity-value",
      style: _normalizeStyle({
        height: `${$options.getPercent(item) + 20}%`
      })
    }, [_createElementVNode("div", _hoisted_2, _toDisplayString((item * 1).toFixed(2) > 0 ? $options.formatWithSpace(Math.floor(item * 1)) : ""), 1)], 4), [[_vShow, $data.show_velocity_value]]), _createElementVNode("div", {
      class: _normalizeClass(['velocity-bar', `bar-${index}`]),
      style: _normalizeStyle({
        height: `${$options.getPercent(item)}%`
      })
    }, null, 6)], 40, _hoisted_1);
  }), 128)), _createElementVNode("div", {
    class: "velocity-avg",
    style: _normalizeStyle({
      bottom: `${$options.getPercent($options.avg)}%`
    })
  }, null, 4), $props.slowMover ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_app_icon, {
    icon: "waves"
  }), _hoisted_4])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true);
}